<template>
    <div class="n-pb-4">
        <div class="c-banner c-banner-home n-col-1 n-border-box n-overflow-hidden">
            <NImage class="c-banner-image n-col-1 n-h-1"
                    type="cover"
                    :src="require('@/assets/image/banner.jpg')">
            </NImage>

            <div class="c-banner-text c-max-width n-m-auto n-p-3 n-flex n-flex-a-c home-banner-text">
                <h1 class="n-c-1 n-flex-s n-text-left c-f-2 n-f-1 n-mr-4 n-m-b-0"
                    v-html="LAN.welcomeBR"></h1>

                <div>
                    <h3 class="n-c-1 n-text-left n-line-height-1"
                        v-html="LAN.intro.i1"></h3>
                    <h3 class="n-c-1 n-text-left n-mt-5 n-line-height-1"
                        v-html="LAN.intro.i2"></h3>
                    <h3 class="n-c-1 n-text-left n-mt-5 n-line-height-1"
                        v-html="LAN.intro.i3"></h3>
                    <h3 class="n-c-1 n-text-left n-mt-5 n-line-height-1"
                        v-html="LAN.intro.i4"></h3>
                </div>
            </div>
        </div>

        <div class="n-col-1 n-bg-1">
            <div class="c-max-width n-m-auto n-p-4">
                <router-link :to="{name: 'ordering', query: {p: '0-1'}}"
                             class="mid n-block n-radius-6 n-p-3 n-bg-1 n-pointer c-hover c-shadow c-tab-link c-tab-link-event">
                    <h2 class="n-text-center n-m-0 n-mb-2 n-line-height-1">{{ LAN.home.sold }}</h2>
                    <h4 class="n-text-center n-m-0 n-mt-1">{{ LAN.home.soldDesc }}</h4>
                    <h4 class="n-text-center n-m-0 n-mt-1 c-hover-target"
                        v-html="LAN.home.soldBtn"></h4>
                </router-link>
            </div>

            <div class="c-max-width-1 n-m-auto n-p-2">
                <div class="n-flex">
                    <div class="n-flex-g n-mr-3">
                        <h3 v-html="LAN.home.sTitle"
                            class="n-mb-6"></h3>
                        <h4 v-html="LAN.home.sContent1"
                            class="n-mb-1"></h4>
                        <h4 v-html="LAN.home.sContent2"
                            class="n-mb-1"></h4>
                        <h4 v-html="LAN.home.sContent3"
                            class="n-mb-1"></h4>
                    </div>
                    <ul class="n-ul n-p-0 tag-list n-flex-s">
                        <li class="c-shadow n-radius-6 n-pointer n-mb-4 n-overflow-hidden">
                            <router-link class="c-tab-border-link c-tab-link-event"
                                         :to="{ name: 'journal' }">
                                <NImage class="tag-list-item n-flex-s n-mr-3"
                                        type="cover"
                                        :src="require('@/assets/image/journal.png')"></NImage>
                                <div class="tag-content c-tab-aim n-col-1 n-h-1 n-flex n-flex-dr-c n-flex-a-c n-flex-j-c">
                                    <h1 class="n-c-1 n-line-height-1 n-mb-1">{{ journalCount }}</h1>
                                    <h4 class="n-c-1 n-m-0">{{ LAN.nav.QQ }}</h4>
                                </div>
                            </router-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <div class="c-max-width-1 n-m-auto n-p-2 n-mt-2"
             v-if="homeCMSData?.length > 0">
            <h2 class="n-f-bold c-f-3">{{ LAN.news.title }}</h2>

            <ul class="n-ul n-p-0 news-list">
                <li class="n-bg-1 n-radius-6 c-shadow n-pointer n-mb-4"
                    v-for="item in homeCMSData"
                    :key="item.id">
                    <router-link :to="{name: 'newsDetail', query: {id: item.id}}"
                                 target="_blank"
                                 class="n-flex n-ptb-4 c-tab-link c-tab-link-event n-col-1">
                        <div class="n-plr-6 n-border-box n-flex-g n-flex-g-w-1-hack n-flex n-flex-dr-c n-flex-a-s n-flex-j-c n-col-1">
                            <h4 class="n-f-6 n-c-4 n-f-bold n-m-0 n-col-1"
                                v-html="item.title"></h4>
                            <h4 class="n-c-4 n-e-2 n-m-0 n-col-1 n-mt-3"
                                v-if="item.fAbstract"
                                v-html="item.fAbstract"></h4>
                        </div>

                        <div class="news-list-right n-flex-s">
                            <h4 class="n-c-4 n-text-center n-m-0">{{ LAN.news.publishDate }}</h4>
                            <h5 class="n-c-4 n-f-bold n-text-center n-m-0">{{item.publishDate}}</h5>
                        </div>
                    </router-link>
                </li>
            </ul>

            <div class="n-flex n-flex-j-c"
                 @click="$router.push({name: 'news'})">
                <button href="javascript:;"
                        class="n-button news-button n-pointer c-tab-link c-tab-link-event">{{ LAN.news.seeAll }}<i class="n-icon n-icon-arrow-down n-inline-block n-icon-size-15 n-ml-1"></i></button>
            </div>
        </div>

        <a href="http://visitor.r20.constantcontact.com/d.jsp?llr=usto4uoab&p=oi&m=1115248086612&sit=5qxj78gib"
           target="_blank"
           class="c-tab-link c-tab-link-event n-flex n-flex-a-c n-keep-word join-mail"
           style="color:#0A87FD">

            <span class="join-icon n-flex-s n-bg-base n-radius-circle n-c-1 n-mr-1 n-flex n-flex-a-c n-flex-j-c n-line-height-1">
                <MailOutlined style="font-size: 15px; margin: -.9px 0 0 .8px;" />
            </span>
            <span class="n-flex-s n-c-base">{{LAN.nav.joinMail}}</span>
        </a>
    </div>
</template>
<script>
    import { mapMutations, mapState } from 'vuex';
    import { StarOutlined, LikeOutlined, MessageOutlined, UndoOutlined, MailOutlined } from '@ant-design/icons-vue';
    import NImage from '@/components/nui/NImage/NImage.vue'

    import nui from '@/assets/script';

    export default {
        name: 'Home',
        computed: {
            ...mapState(nui.extendVue.extendState.concat([])),
        },
        data () {
            return nui.extend(true, {}, nui.extendVue.extendData, {
                journalCount: '-',
                bookCount: '-',
                homeCMSData: []
            })
        },
        methods: nui.extend(true, {}, nui.extendVue.extendMethods, {
            ...mapMutations(nui.extendVue.extendMutations.concat()),

            NMounted () {
                this.loadData()
            },
            loadData () {
                this.request(this.API.homeData, {}).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE && res.data) {
                        this.journalCount = res.data.totalPeriodicals;
                        this.bookCount = res.data.totalBooks;
                    }
                })


                this.request(this.API.homeCMSData, {}).then(res => {
                    if (res.code == this.REQUEST_SUCCESS_CODE && res.data) {
                        this.homeCMSData = res.data;

                        this.$nextTick(() => {
                            this.parseMathJax()
                        })
                    }
                })

                // this.request(this.API.journal, { requestId: 'journal', params: { current: 1, size: 9999999, keyword: '' } }),

                // this.journalCount = 29;
                // this.bookCount = 364
                // Promise.all([
                // ]).then(res => {
                //     var [r1, r2, r3, r4] = res, bookCount = 0;

                //     if (r1.code == this.REQUEST_SUCCESS_CODE) {
                //         this.journalCount = r1.data.total;
                //     }

                //     if (r2.code == this.REQUEST_SUCCESS_CODE) {
                //         bookCount += r2.data.total;
                //     }

                //     if (r3.code == this.REQUEST_SUCCESS_CODE) {
                //         bookCount += r3.data.total;
                //     }

                //     if (r4.code == this.REQUEST_SUCCESS_CODE) {
                //         r4.data.forEach(item => {
                //             bookCount += parseInt(item.count)
                //         });
                //     }

                //     this.bookCount = bookCount;
                // })
            }
        }),
        components: {
            StarOutlined,
            LikeOutlined,
            MessageOutlined,
            NImage,
            UndoOutlined,
            MailOutlined
        },
        ...nui.extendVue.extendLife
    }
</script>
<style lang="scss" scoped>
    .news-button {
        height: 40px;
        line-height: 40px;
        border: 1px solid $color-base;
        color: $color-base;
        padding: 0 50px;
        border-radius: 20px;
        background-color: #fff;
        margin: 0 auto;
        transition: all 0.3s;

        &:hover {
            color: $font-color-1;
            border: 1px solid $color-red;
            background-color: $color-base;

            i {
                color: $font-color-1;
            }
        }

        i {
            transform: rotate(-90deg);
        }
    }

    .tag-list {
        width: 210px;

        li {
            position: relative;

            &:hover {
                .tag-list-item {
                    transform: scale(1.2);
                }
            }
        }

        .tag-list-item {
            transition: all 0.3s;
            width: 100%;
            height: 120px;
        }

        .tag-content {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 2;

            &:after {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background-color: rgba(0, 0, 0, 0.5);
                z-index: 1;
            }

            h1 {
                position: relative;
                z-index: 2;
                font-size: 36px;

                small {
                    font-size: 16px;
                    position: relative;
                    top: -2px;
                }
            }

            h4 {
                position: relative;
                z-index: 2;
            }
        }
    }

    .home-banner-text {
        h1 {
            width: 465px;
            line-height: 1.2;
        }
    }

    .mid {
        width: 70%;
        margin: 0 auto;
        background-image: linear-gradient(
            90deg,
            rgba(251, 225, 230, 0.69),
            rgba(255, 255, 255, 0)
        );
    }

    .join-mail {
        position: fixed;
        right: 0;
        bottom: 180px;
        height: 40px;
        border-top-left-radius: 20px;
        border-bottom-left-radius: 20px;
        box-shadow: 0 0 5px 2px rgba(0, 0, 0, 0.1);
        display: flex;
        padding: 0 10px 0 5px;
        align-items: center;
        transition: all 0.2s;
        max-width: 40px;

        &:hover,
        &:focus {
            max-width: 999px;
        }

        .join-icon {
            width: 30px;
            height: 30px;
        }
    }

    @media screen and (max-width: 1100px) {
        .home-banner-text {
            display: block;

            h1 {
                margin-bottom: 10px;
                width: 100%;
                text-align: center;
            }

            h3 {
                margin-top: 10px;
            }
        }

        .mid {
            width: 100%;
        }
    }
</style>